import { ShieldCheck, Globe2, BarChart3 } from 'lucide-react';
import { m as motion, useReducedMotion } from 'framer-motion';
import ScrambleCounter from '../ScrambleCounter';
import styles from '../../pages/Home.module.css';

const FACTS = [['Lots', 'Serialized'], ['Inspection', 'Documented'], ['Trace', 'End-to-End']];
const CREDENTIALS = [
  { code: 'ISO 9001', body: 'Quality Management System', id: 'iso-9001', icon: ShieldCheck },
  { code: 'ITAR', body: 'Registered · Export-Controlled', id: 'itar', icon: Globe2 },
];

export const HomeReadout = () => {
  const reducedMotion = useReducedMotion();
  const reveal = delay => ({ initial: reducedMotion ? false : { opacity: 0.45, y: 12 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, amount: 0.15 }, transition: { duration: reducedMotion ? 0 : 0.65, delay: reducedMotion ? 0 : delay, ease: [0.22, 1, 0.36, 1] } });
  return <div className={styles.facts} data-testid="tactical-readout" data-motion-managed="readout">
  <div className={styles.primaryFacts}>
    <motion.div {...reveal(0)} data-testid="readout-hero">
      <div className={styles.factLabel} data-testid="home-output-label"><BarChart3 size={16} aria-hidden="true" />Annual Output · Cartridges</div>
      <div className={styles.outputValue} data-testid="home-output-value" aria-label="3M+"><ScrambleCounter value="3M" duration={1000} delay={120} testId="home-output-counter" /><span className={styles.outputPlus}>+</span></div>
      <p className={styles.factContext} data-testid="home-output-context">Across multiple defense programs</p>
    </motion.div>
    <motion.div {...reveal(0.08)} className={styles.responseFact} data-testid="readout-rate">
      <div className={styles.factLabel} data-testid="readout-support-label">Initial Response Within</div>
      <div className={styles.responseValue} data-testid="readout-support-value"><ScrambleCounter value="24 HOURS" duration={1000} delay={200} testId="home-response-counter" /></div>
      <span className={styles.responseDial} aria-hidden="true" data-testid="home-response-dial">
        {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map(deg => (
          <motion.span
            key={deg}
            initial={reducedMotion ? false : { opacity:0 }}
            whileInView={{ opacity:1 }}
            viewport={{ once:true, amount:0.4 }}
            transition={{ duration:reducedMotion ? 0 : 0.3, delay:reducedMotion ? 0 : 0.35 + (deg / 30) * 0.045 }}
            className={deg === 0 ? styles.dialTickMajor : styles.dialTick}
            style={{ transform: `translate(-50%, -100%) rotate(${deg}deg) translateY(-12px)` }}
          />
        ))}
        <span className={styles.dialHand} data-testid="home-response-clock-hand" /><span className={styles.dialCenter} />
      </span>
    </motion.div>
  </div>
  <dl className={styles.miniFacts}>{FACTS.map(([label, value]) => <div key={label} data-testid={`home-fact-${label.toLowerCase()}`}><dt>{label}</dt><dd data-testid={`home-fact-${label.toLowerCase()}-value`}>{value}</dd></div>)}</dl>
  <div className={styles.factCredentials} data-testid="readout-certs">
    {CREDENTIALS.map((item, index) => <motion.div {...reveal(0.12 + index * 0.08)} key={item.id} data-testid={`readout-cert-${item.id}`}>
      <span className={styles.credentialIcon}><item.icon size={20} aria-hidden="true" /></span>
      <div className={styles.credentialBody}><h3>{item.code}</h3><p>{item.body}</p></div>
    </motion.div>)}
  </div>
  <div className={styles.productionStatus} data-testid="home-production-status">
    <span data-testid="home-made-in-usa">Made in USA</span>
    <span data-testid="home-production-heritage">Built in USA · Trusted for Decades</span>
    <span data-testid="home-continuous-production">Continuous Production</span>
  </div>
</div>;
};
